<template>
    <div class="col-12">
        <!-- <a href="/samsung-galaxy-s23-series" target="_blank" class="image-res"> -->
            <a href="https://www.happimobiles.com/oppo-reno-13-pro-5g-mist-lavender-12gb-512gb" target="_blank" class="image-res">
            <img 
            v-lazy-load data-src="https://happimobiles.s3.ap-south-1.amazonaws.com/imageurl/WhatsApp%20Image%202025-03-11%20at%2012.51.21%20PM.jpeg"
            alt="happimobiles"
            />
            <!-- <img 
            v-lazy-load data-src="https://s3.ap-south-1.amazonaws.com/happimobiles/retool-upload/7eae9b3a-c5e0-44fe-b10a-beef8b619639.png"
            alt="happimobiles"
            /> -->
        </a>
    </div>
</template>
<script>
export default {
    name: 'HomeDeskFullAd',
    
    
}
</script>
